import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function SaltSalesBySector({ sales = [] }) {
  return (
    <MDBox>
      <MDTypography variant="h6" color="dark" mb={2}>
        En Sık Kullanılan Tuzlar
      </MDTypography>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          height: "400px",
          overflow: "auto",
          border: "1px solid #e9ecef",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f8f9fa" }}>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "left",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Sektör
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "left",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Tuz Türü
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "right",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Toplam Ton
              </th>
            </tr>
          </thead>
          <tbody>
            {sales.length > 0 ? (
              sales.slice(0, 10).map((sale, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid #e9ecef",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.target.parentElement.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.target.parentElement.style.backgroundColor = "transparent";
                  }}
                >
                  <td
                    style={{
                      padding: "12px 16px",
                      color: "#344767",
                      fontSize: "14px",
                    }}
                  >
                    {sale.sector || "Bilinmeyen Sektör"}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      color: "#344767",
                      fontSize: "14px",
                    }}
                  >
                    {sale.saltType || "Bilinmeyen Tuz"}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      textAlign: "right",
                      color: "#344767",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    {sale.totalTons ? sale.totalTons.toLocaleString() : 0} ton
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: "24px 16px",
                    textAlign: "center",
                    color: "#344767",
                    fontSize: "14px",
                  }}
                >
                  Henüz satış verisi bulunmuyor
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </MDBox>
  );
}

SaltSalesBySector.propTypes = {
  sales: PropTypes.arrayOf(
    PropTypes.shape({
      sector: PropTypes.string,
      saltType: PropTypes.string,
      totalTons: PropTypes.number,
    })
  ),
};

export default SaltSalesBySector;
